module.exports = __webpack_public_path__ + "static/media/reface_left_side_decorator.ffe31b66.png";